module.exports = __webpack_public_path__ + "static/Deadline_logo.16b24ab5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/png/Deadline_logo.png
// module id = 1185
// module chunks = 170264817138936